(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/objects/action-bar-xperten.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/objects/action-bar-xperten.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.objects = svs.matchen.objects || {};

  svs.matchen.objects.ActionBarXperten = svs.matchen.objects.ActionBarBase.extend({
    initialize: function() {
      this.listenTo(
        this.options.model,
        'change:active change:systemSize',
        this.handleExpertenChange
      );
      if (this.options.model.isActive()) {
        this.showActionBar();
      }
    },

    handleExpertenChange: function() {
      if (this.options.model.isActive()) {
        this.showActionBar();
      } else {
        this.hideActionBar();
      }
    },

    showActionBar: function() {
      var leftButton = {
        text: 'PIX! ' + this.options.model.getSystemSize() + ' rader',
        icon: null,
        visible: true
      };

      if (svs.core.detect.formfactor.mobile()) {
        leftButton.type = 'button';
        leftButton.callback = this.onClickXperten;
      } else {
        leftButton.type = 'text';
      }

      svs.sport.actionbar.show(
        {
          cssClass: 'actionbar-matchen actionbar-matchen-xperten',
          leftButton: leftButton,
          centerButton: {
            type: 'link',
            icon: 'icon-default icon-refresh icon-300 padding-right-1',
            visible: true,
            callback: this.onClickRefresh
          },
          rightButton: {
            type: 'link',
            text: '',
            icon: 'icon-default icon-300 icon-dustbin',
            visible: true,
            callback: this.onClickSpelaFritt
          }
        },
        this
      );
    },

    onClickXperten: function() {
      this.options.showXpertenSelectorCallback();
    },

    onClickRefresh: function() {
      this.options.refreshXpertenCallback();
    },

    onClickSpelaFritt: function() {
      this.options.clearCouponCallback();
    }
  });
})(Backbone, _, svs);


 })(window);